import { getConnectionPool } from "../../core/connectionPool";
import { Task } from "./task";
import { request } from "../../proto/bundle";
import Long from "long";
import { checkMigrate, globalCache } from "../../init/sdkInit";

const CHUNK_SIZE = 1024 * 1024 * 4; // 4MB
const BATCH_SIZE = 8; // Number of chunks per batch
function uint8ToHex(bytes: Uint8Array): string {
  return Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
}
export class File {
  private fileUuid!: Uint8Array;
  private versionUuid!: Uint8Array;
  private parentPath: string = "/";
  private fileName: string = "";
  private new!: boolean
  private size: number = 0;
  private sizes: (number | Long)[] = [];
  private versions: Uint8Array[] = [];
  private currentVersion: Uint8Array = new Uint8Array();
  private creationDate: number | Long = 0;
  private lastModifiedDate: number | Long = 0;
  private owner: string = "";
  private fileType: string = "";
  private tags: string[] = []
  constructor() {

  }
  setFileType(type: string) {
    this.fileType = type;
  }
  setTags(tags: string[]) {
    this.tags = tags;
  }
  setFileUuid(uuid: Uint8Array) {
    this.fileUuid = uuid;
  }
  setVersionUuid(uuid: Uint8Array) {
    this.versionUuid = uuid;
  }
  setParentPath(path: string) {
    this.parentPath = path;
  }
  setFileName(name: string) {
    this.fileName = name;
  }
  setNew(newFile: boolean) {
    this.new = newFile;
  }
  setSize(size: number) {
    this.size = size;
  }
  setSizes(sizes: (number | Long)[]) {
    this.sizes = sizes;
  }
  setVersions(versions: Uint8Array[]) {
    this.versions = versions;
  }
  setCurrentVersion(version: Uint8Array) {
    this.currentVersion = version;
  }
  setCreationDate(date: number | Long) {
    this.creationDate = date;
  }
  setLastModifiedDate(date: number | Long) {
    this.lastModifiedDate = date;
  }
  setOwner(owner: string) {
    this.owner = owner;
  }
  getParentPath() {
    return this.parentPath;
  }
  getName() {
    return this.fileName;
  }
  getSize() {
    return this.size;
  }
  getLastModifiedDate() {
    return this.lastModifiedDate;
  }
  getOwner() {
    return this.owner;
  }
  getCreationDate() {
    return this.creationDate;
  }
  getFileUuId(): string {
    return Array.from(this.fileUuid).map(b => b.toString(16).padStart(2, '0')).join('');
  }
  getFileUuidArray(): Uint8Array {
    return this.fileUuid;
  }
  getFileVersionUuid(): Uint8Array {
    return this.versionUuid;
  }

  getFileType(): string {
    return this.fileType
  }
  getFileTags(): string[] {
    return this.tags
  }

  getSizeString() {
    if (this.size < 1024) {
      return `${this.size} B`;
    } else if (this.size < 1024 * 1024) {
      return `${(this.size / 1024).toFixed(2)} KB`;
    } else if (this.size < 1024 * 1024 * 1024) {
      return `${(this.size / (1024 * 1024)).toFixed(2)} MB`;
    } else {
      return `${(this.size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
  }

  getCreationDateString() {
    if (this.creationDate instanceof Long) {
      return new Date(this.creationDate.toNumber() * 1000).toISOString().replace('T', ' ').substring(0, 19);
    } else {
      return new Date(this.creationDate * 1000).toISOString().replace('T', ' ').substring(0, 19);
    }
  }

  getLastModifiedDateString() {
    if (this.lastModifiedDate instanceof Long) {
      return new Date(this.lastModifiedDate.toNumber() * 1000).toISOString().replace('T', ' ').substring(0, 19);
    } else {
      return new Date(this.lastModifiedDate * 1000).toISOString().replace('T', ' ').substring(0, 19);
    }
  }




  async getThumbnail(own_files: boolean): Promise<Uint8Array | null | undefined> {
    // hex encode version string.
    const versionString = Array.from(this.currentVersion).map(b => b.toString(16).padStart(2, '0')).join('');
    let parent_path = this.parentPath;
    let fileName = this.fileName;
    if (own_files) {
      parent_path = "files" + parent_path;
    } else {
      if (this.replaceParentPath(parent_path)) {
        // only for teams
        parent_path = "/shared/";
      }
      if (this.replaceName(parent_path)) {
        fileName = uint8ToHex(this.fileUuid);
      }
    }
    const cache_key = parent_path + "/" + this.fileName + "-" + versionString + "-thumbnail";
    if (globalCache.has(cache_key)) {
      return globalCache.get(cache_key);
    }

    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      getThumbnail: request.GetThumbnail.create({
        parentPath: parent_path,
        fileName: fileName,
        versionUuid: this.currentVersion,
        typeOfPath: 1
      }),
    });
    return pool.sendAndWait(req).then(resp => {
      checkMigrate(resp?.getThumbnail?.status)
      if (resp?.getThumbnail?.status !== 0) {
        throw new Error(`Get thumbnail failed with status ${resp?.getThumbnail?.status}`);
      }
      if (resp?.getThumbnail?.thumbnail) {
        globalCache.set(cache_key, resp.getThumbnail.thumbnail);
      }
      return resp?.getThumbnail?.thumbnail;

    })
  }
  replaceParentPath(parentPath: string): boolean {
    let splitted_parts = parentPath
      .split('/')
      .filter(part => part.trim().length > 0);
    if (splitted_parts.length == 3 && splitted_parts[0] == "shared" && splitted_parts[1] == "teams") return true;
    return false;
  }
  replaceName(parentPath: string): boolean {
    let splitted_parts = parentPath
      .split('/')
      .filter(part => part.trim().length > 0);
    if (splitted_parts.length == 1) {
      if (splitted_parts[0] == "shared") {
        return true;
      }
    }
    return false;
  }
  async setThumbnail(thumbnail: Uint8Array, own_files: boolean): Promise<boolean> {
    const pool = await getConnectionPool();
    let parent_path = this.parentPath;
    let fileName = this.fileName;
    if (own_files) {
      parent_path = "files" + parent_path;
    } else {
      if (this.replaceParentPath(parent_path)) {
        // only for teams
        parent_path = "/shared/";
      }
      if (this.replaceName(parent_path)) {
        fileName = uint8ToHex(this.fileUuid);
      }
    }
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      setThumbnail: request.SetThumbnail.create({
        parentPath: parent_path,
        fileName: fileName,
        versionUuid: this.versionUuid,
        typeOfPath: 1,
        thumbnail: thumbnail
      }),
    });
    return pool.sendAndWait(req).then(resp => {
      checkMigrate(resp?.setThumbnail?.status)
      if (resp?.setThumbnail?.status !== 0) {
        throw new Error(`Set thumbnail failed with status ${resp?.setThumbnail?.status}`);
      }
      const versionString = Array.from(this.versionUuid).map(b => b.toString(16).padStart(2, '0')).join('');
      const cache_key = this.parentPath + "/" + this.fileName + "-" + versionString + "-thumbnail";
      globalCache.set(cache_key, thumbnail);
      return true;
    })
  }

  /** Initializes the File object from a cloud path.
   * * @param cloudPath - The path in the cloud where the file is located.
   * * * @throws {Error} If the file metadata cannot be retrieved.
   * * * @returns {Promise<void>} A promise that resolves when the initialization is complete.
   * */
  async initFromPath(cloudPath: string): Promise<void> {

    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      getMetaFromPath: request.GetMetaFromPath.create({
        path: cloudPath,
        trashed: false,
        typeOfPath: 0,
      }),
    });

    return pool.sendAndWait(req).then(resp => {
      checkMigrate(resp.getMetaFromPath.status)
      if (!resp.getMetaFromPath?.meta || !resp.getMetaFromPath.meta.fileMeta) {
        throw new Error(`Get Meta from path failed with status ${resp.getMetaFromPath?.status}`);
      }
      const fileMeta = resp.getMetaFromPath.meta.fileMeta;
      this.setFileUuid(fileMeta.uuid ?? new Uint8Array());
      this.setVersionUuid(fileMeta.currentVersion ?? new Uint8Array());
      this.setNew(false);
      this.setSizes(fileMeta.sizes || []);
      this.setVersions(fileMeta.versions || []);
      this.setCurrentVersion(fileMeta.currentVersion || new Uint8Array());
      this.setCreationDate(fileMeta.creationDate ? Long.fromValue(fileMeta.creationDate).toNumber() : 0);
      this.setLastModifiedDate(fileMeta.lastModifiedDate ? Long.fromValue(fileMeta.lastModifiedDate).toNumber() : 0);
      this.setOwner(fileMeta.owner || "");
    });
  }


  /**
   * Uploads a file to the cloud storage.
   * @param localFilePath - The path to the local file to upload.
   * @param destinationPath - The path in the cloud where the file will be uploaded.
   * @param onProgress - Optional callback to track upload progress.
   * * @throws {Error} If the file does not exist or if the upload fails.
   * * @returns {Promise<void>} A promise that resolves when the upload is complete.
   * */
  // async uploadFile(
  //   localFilePath: string,
  //   destinationPath: string,
  //   onProgress?: (progress: { loaded: number; total: number }) => void
  // ) {
  //   if (!fs.existsSync(localFilePath)) {
  //     throw new Error(`File not found: ${localFilePath}`);
  //   }

  //   this.parentPath = destinationPath || "/";
  //   this.fileName = path.basename(localFilePath);
  //   const fileSize = fs.statSync(localFilePath).size;
  //   const task = new Task(0, 0, 0, fileSize);
  //   if (onProgress) {
  //     onProgress({
  //       loaded: 0,
  //       total: fileSize,
  //     });
  //   }
  //   const pool = getConnectionPool();

  //   const startReq = request.Request.create({
  //     id: null,
  //     startWrite: request.StartWrite.create({
  //       uuid: this.fileUuid,
  //       filesize: fileSize,
  //       parentPath: this.parentPath,
  //       filename: this.fileName,
  //     }),
  //   });

  //   const startResp = await pool.sendAndWait(startReq);
  //   if (startResp.startWrite?.status !== 0 || !startResp.startWrite?.uuid) {
  //     throw new Error(`StartWrite failed with status ${startResp.startWrite?.status}`);
  //   }

  //   this.versionUuid = startResp.startWrite.uuid;

  //   const fd = fs.openSync(localFilePath, "r");
  //   try {
  //     let offset = 0;

  //     while (offset < fileSize) {
  //       const batch: Promise<void>[] = [];

  //       for (let i = 0; i < BATCH_SIZE && offset < fileSize; i++) {
  //         const chunkLength = Math.min(CHUNK_SIZE, fileSize - offset);
  //         const buffer = Buffer.alloc(chunkLength);
  //         fs.readSync(fd, buffer, 0, chunkLength, offset);

  //         const chunkOffset = offset;
  //         const chunkData = new Uint8Array(buffer);

  //         batch.push(this.putChunk(chunkData, chunkOffset, task, onProgress));
  //         offset += chunkLength;
  //       }

  //       await Promise.all(batch);
  //     }
  //   } finally {
  //     fs.closeSync(fd);
  //   }


  //   const finalizeReq = request.Request.create({
  //     id: null,
  //     finalizeWrite: request.FinalizeWrite.create({
  //       uuid: this.fileUuid,
  //       versionUuid: this.versionUuid,
  //     }),
  //   });

  //   const finalizeResp = await pool.sendAndWait(finalizeReq);
  //   if (finalizeResp.finalizeWrite?.status !== 0) {
  //     throw new Error(`FinalizeWrite failed with status ${finalizeResp.finalizeWrite?.status}`);
  //   }

  //   if (onProgress) {
  //     onProgress({
  //       loaded: fileSize,
  //       total: fileSize,
  //     });
  //   }

  // }

  /**
   * Downloads a file from the cloud storage.
   * @param cloudPath - The path in the cloud where the file is located.
   * @param destinationPath - The local path where the file will be saved.
   * @param onProgress - Optional callback to track download progress.
   * @throws {Error} If the file does not exist or if the download fails.
   * @returns {Promise<void>} A promise that resolves when the download is complete.
   */
  // async downloadFile(
  //   cloudPath: string,
  //   destinationPath: string,
  //   onProgress?: (progress: { loaded: number; total: number | Long }) => void
  // ) {
  //   console.log("cloudPath", cloudPath);
  //   console.log("destinationPath", destinationPath);
  //   const pool = getConnectionPool();
  //   let req = request.Request.create({
  //     id: null,
  //     getMetaFromPath: request.GetMetaFromPath.create({
  //       path: cloudPath,
  //       trashed: false
  //     }),
  //   });
  //   let resp = await pool.sendAndWait(req);
  //   if (!resp.getMetaFromPath?.meta) {
  //     throw new Error(`Get Meta from path failed with status ${resp.startWrite?.status}`);
  //   }
  //   console.log(resp.getMetaFromPath.meta.fileMeta)
  //   this.versionUuid = resp.getMetaFromPath.meta.fileMeta?.currentVersion ?? new Uint8Array();


  //   const fileName = resp.getMetaFromPath.meta.fileMeta?.name ?? path.basename(cloudPath);
  //   const destFilePath = path.join(destinationPath, fileName);
  //   // const fileSize = resp.getMetaFromPath.meta.fileMeta.


  //   let fileSize;
  //   const versions = resp.getMetaFromPath.meta.fileMeta?.versions ?? [];
  //   const sizes = resp.getMetaFromPath.meta.fileMeta?.sizes ?? [];
  //   const versionIndex = versions.findIndex((v: Uint8Array) =>
  //     Buffer.from(v).equals(Buffer.from(this.versionUuid))
  //   );
  //   if (versionIndex !== -1 && sizes[versionIndex] !== undefined) {
  //     fileSize = sizes[versionIndex];
  //   } else {
  //     throw new Error("Could not determine file size for the specified version.");
  //   }
  //   const fd = fs.openSync(destFilePath, "w");
  //   try {
  //     fileSize = typeof fileSize === "number" ? fileSize : fileSize.toNumber();
  //     let offset = 0;
  //     const task = new Task(0, 0, 0, fileSize);

  //     if (onProgress) {
  //       onProgress({
  //         loaded: 0,
  //         total: fileSize,
  //       });
  //     }


  //     while (offset < fileSize) {
  //       const batch: Promise<{ data: Uint8Array; chunkOffset: number; chunkLength: number }>[] = [];
  //       for (let i = 0; i < BATCH_SIZE && offset < fileSize; i++) {
  //         const chunkOffset = offset;
  //         const chunkLength = Math.min(CHUNK_SIZE, fileSize - chunkOffset);
  //         batch.push(
  //           this.getChunk(chunkOffset, cloudPath, task, onProgress).then(data => ({
  //             data,
  //             chunkOffset,
  //             chunkLength,
  //           }))
  //         );
  //         offset += chunkLength;
  //       }

  //       const results = await Promise.all(batch);
  //       for (const { data, chunkOffset, chunkLength } of results) {
  //         fs.writeSync(fd, Buffer.from(data), 0, chunkLength, chunkOffset);
  //       }
  //     }

  //     if (onProgress) {
  //       onProgress({
  //         loaded: fileSize,
  //         total: fileSize,
  //       });
  //     }
  //   } finally {
  //     fs.closeSync(fd);
  //   }
  // }

  /**
   * Copies the file to a new location in the cloud storage.
   * @param new_path - The destination path in the cloud where the file will be copied.
   * @param new_name - Optional new name for the copied file. If not provided, the original name is used.
   * @throws {Error} If the copy operation fails.
   * @returns {Promise<void>} A promise that resolves when the copy is complete.
   */

  async copy(new_path: string, new_name?: string): Promise<void> {
    let parentPath = new_path;
    if (!parentPath.endsWith("/")) {
      parentPath = parentPath + "/";
    }
    if (!new_name) {
      new_name = this.fileName;
    }
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      copyFile: request.CopyFile.create({
        fileFullPath: this.parentPath + "/" + this.fileName,
        destinationParentPath: parentPath,
        newFileName: new_name,
        typeOfPath: 0
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.copyFile.status)

    if (resp.copyFile?.status !== 0) {
      throw new Error(`Copy file failed with status ${resp.copyFile?.status}`);
    }
    return;
  }

  /**
   * Moves the file to a new location in the cloud storage.
   * @param new_path - The destination path in the cloud where the file will be moved.
   * @param new_name - Optional new name for the moved file. If not provided, the original name is used.
   * @throws {Error} If the move operation fails.
   * @returns {Promise<void>} A promise that resolves when the move is complete.
   */
  async move(new_path: string, new_name?: string): Promise<void> {
    let parentPath = new_path;
    if (!parentPath.endsWith("/")) {
      parentPath = parentPath + "/";
    }
    if (!new_name) {
      new_name = this.fileName;
    }
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      moveFile: request.MoveFile.create({
        fileFullPath: this.parentPath + "/" + this.fileName,
        destinationParentPath: parentPath,
        newFileName: new_name,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.moveFile.status)
    if (resp.moveFile?.status !== 0) {
      throw new Error(`Move file failed with status ${resp.moveFile?.status}`);
    }
    return;
  }

  /**
   * Renames the file in the cloud storage.
   * @param new_name - The new name for the file.
   * @throws {Error} If the new name is empty or if the rename operation fails.
   * @returns {Promise<void>} A promise that resolves when the rename is complete.
   */
  async rename(new_name: string): Promise<void> {
    // console.log("new_name",new_name);
    // console.log("this.parentPath",this.parentPath);
    // console.log("this.fileName",this.fileName);
    if (!new_name || new_name.trim() === "") {
      throw new Error("New name cannot be empty.");
    }
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      renameFile: request.RenameFile.create({
        filePath: this.parentPath + "/" + this.fileName,
        newName: new_name,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.renameFile.status)
    if (resp.renameFile?.status !== 0) {
      throw new Error(`Rename file failed with status ${resp.renameFile?.status}`);
    }
    this.fileName = new_name;
    return;
  }

  /**
   * Restores a trashed file in the cloud storage.
   * @throws {Error} If the restore operation fails.
   * @returns {Promise<void>} A promise that resolves when the restore is complete.
   */
  async restore(): Promise<void> {
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      untrashFile: request.UntrashFile.create({
        fileFullPath: this.parentPath + "/" + this.fileName,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.untrashFile.status)
    if (resp.untrashFile?.status !== 0) {
      throw new Error(`Restore file failed with status ${resp.untrashFile?.status}`);
    }
    return;
  }

  /**
   * Deletes the file from the cloud storage.
   * @param isPerm - If true, the file will be permanently deleted(needs to be in trash). If false, it will be moved to trash.
   * @throws {Error} If the delete operation fails.
   * @returns {Promise<void>} A promise that resolves when the delete is complete.
   */
  async remove(isPerm: boolean): Promise<void> {
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      removeFile: request.RemoveFile.create({
        fileFullPath: this.parentPath + "/" + this.fileName,
        isPerm: isPerm
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.removeFile.status)
    if (resp.removeFile?.status !== 0) {
      throw new Error(`Delete file failed with status ${resp.removeFile?.status}`);
    }
    return;
  }

  /**
   * Resets the file version in the cloud storage.
   * @param version - The version ID to reset to.
   * @throws {Error} If the version ID is invalid or if the reset operation fails.
   * @returns {Promise<void>} A promise that resolves when the reset is complete.
   */
  async resetVersion(version: string): Promise<void> {
    const pool = await getConnectionPool();
    const versionUUID = new Uint8Array(version.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
    let parentPath = this.parentPath;
    if (!parentPath.endsWith("/")) {
      parentPath = parentPath + "/";
    }

    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      resetVersion: request.ResetVersion.create({
        filePath: parentPath + this.fileName,
        versionId: versionUUID,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.resetVersion.status)
    if (resp.resetVersion?.status !== 0) {
      throw new Error(`Reset file version failed with status ${resp.resetVersion?.status}`);
    }
    return;
  }

  async removeVersion(version: string): Promise<void> {
    const pool = await getConnectionPool();
    const versionUUID = new Uint8Array(version.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
    let parentPath = this.parentPath;
    if (!parentPath.endsWith("/")) {
      parentPath = parentPath + "/";
    }

    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      removeVersion: request.RemoveVersion.create({
        parentPath: parentPath,
        fileName: this.fileName,
        versionUuid: versionUUID,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.removeVersion.status)
    if (resp.removeVersion?.status !== 0) {
      throw new Error(`Remove file version failed with status ${resp.removeVersion?.status}`);
    }
    return;
  }
  /**
   * Lists all versions of the file in the cloud storage.
   * @throws {Error} If the file metadata cannot be retrieved.
   * @returns {Promise<{ versions: string[]; currentVersion: string; sizes: number[]; creationDates: string[] }>} A promise that resolves with an object containing version details.
   */
  async listVersions(): Promise<{ versions: string[]; currentVersion: string; sizes: number[]; creationDates: string[]; }> {
    const pool = await getConnectionPool();
    const list: string[] = [];
    const sizes: number[] = [];
    const creation_dates: string[] = [];
    const parentPath = this.parentPath.endsWith("/") ? this.parentPath : this.parentPath + "/";
    const full_path = parentPath + this.fileName;
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      getMetaFromPath: request.GetMetaFromPath.create({
        path: full_path,
        trashed: false,
        typeOfPath: 0
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.getMetaFromPath.status)
    if (!resp.getMetaFromPath?.meta || !resp.getMetaFromPath.meta.fileMeta) {
      throw new Error(`Get Meta from path failed with status ${resp.getMetaFromPath?.status}`);
    }
    const fileMeta = resp.getMetaFromPath.meta.fileMeta;
    const versions = fileMeta.versions || [];
    for (let i = 0; i < versions.length; i++) {
      const version = Array.from(versions[i]).map(b => b.toString(16).padStart(2, '0')).join('');
      const versionCreationDates = fileMeta.versionCreationDates ?? [];
      const timestamp = versionCreationDates[i] ? Long.fromValue(versionCreationDates[i]).toNumber() : 0;
      const date = new Date(timestamp * 1000).toISOString().replace('T', ' ').substring(0, 19);
      list.push(version);
      creation_dates.push(date);
      sizes.push((fileMeta.sizes?.[i]) ? Long.fromValue(fileMeta.sizes[i]).toNumber() : 0);
    }
    const currentVersion = fileMeta.currentVersion
      ? Array.from(fileMeta.currentVersion).map(b => b.toString(16).padStart(2, '0')).join('')
      : '';
    return {
      versions: list,
      currentVersion: currentVersion,
      sizes: sizes,
      creationDates: creation_dates,
    };
  }

  async getChunk(offset: number, cloudPath: string, task: Task, remaining_chunk_size: number, onProgress?: any): Promise<Uint8Array> {
    const pool = await getConnectionPool();
    const offsetBuffer = new Uint8Array(8);
    let tempOffset = BigInt(offset);
    for (let i = 7; i >= 0; i--) {
      offsetBuffer[i] = Number(tempOffset & 0xffn);
      tempOffset >>= 8n;
    }
    const chunkUuid = new Uint8Array(offsetBuffer.length + this.versionUuid.length);
    chunkUuid.set(offsetBuffer, 0);
    chunkUuid.set(this.versionUuid, offsetBuffer.length);
    return await pool.getChunk(chunkUuid, this.versionUuid, cloudPath, task, onProgress, remaining_chunk_size, this.fileUuid);
  }

  async putChunk(data: Uint8Array, offset: number, task: Task, onProgress: any): Promise<void> {
    const pool = await getConnectionPool();
    const offsetBuffer = new Uint8Array(8);
    let tempOffset = BigInt(offset);
    for (let i = 7; i >= 0; i--) {
      offsetBuffer[i] = Number(tempOffset & 0xffn);
      tempOffset >>= 8n;
    }
    const chunkUuid = new Uint8Array(offsetBuffer.length + this.versionUuid.length);
    chunkUuid.set(offsetBuffer, 0);
    chunkUuid.set(this.versionUuid, offsetBuffer.length);
    await pool.putChunk(chunkUuid, this.versionUuid, data, offset, task, onProgress);
  }

  /**
   * Upload multiple chunks on the SAME connection. Sends all blocks from all chunks
   * interleaved, keeping the connection saturated, then waits for all responses.
   */
  async putChunks(chunks: { data: Uint8Array; offset: number }[], task: Task, onProgress: any): Promise<void> {
    const pool = await getConnectionPool();
    const chunkUuids: Uint8Array[] = [];
    for (const chunk of chunks) {
      const offsetBuffer = new Uint8Array(8);
      let tempOffset = BigInt(chunk.offset);
      for (let i = 7; i >= 0; i--) {
        offsetBuffer[i] = Number(tempOffset & 0xffn);
        tempOffset >>= 8n;
      }
      const chunkUuid = new Uint8Array(offsetBuffer.length + this.versionUuid.length);
      chunkUuid.set(offsetBuffer, 0);
      chunkUuid.set(this.versionUuid, offsetBuffer.length);
      chunkUuids.push(chunkUuid);
    }
    await pool.putChunks(
      chunkUuids,
      this.versionUuid,
      chunks.map(c => c.data),
      chunks.map(c => c.offset),
      task,
      onProgress
    );
  }
  async startWrite(fileType: string) {
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      startWrite: request.StartWrite.create({
        uuid: this.fileUuid,
        filesize: this.size,
        parentPath: this.parentPath,
        filename: this.fileName,
        fileType: fileType,
        typeOfPath: 0 // ignore value as of now.
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.startWrite.status)
    if (resp.startWrite?.status !== 0 || !resp.startWrite?.uuid)
      throw new Error(`StartWrite failed with status ${resp.startWrite?.status}`);
    this.versionUuid = resp.startWrite.uuid;
    this.fileUuid = resp.startWrite.fileUuiid;
    return resp.startWrite.uuid;
  }
  async finalizeWrite(fileType: string, tags: string[], size: number | Long) {
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      finalizeWrite: request.FinalizeWrite.create({
        uuid: this.fileUuid,
        versionUuid: this.versionUuid,
        fileType: fileType,
        tags: tags,
        fileSize: size,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.finalizeWrite.status)
    if (resp.finalizeWrite?.status !== 0) {
      throw new Error(`FinalizeWrite failed with status ${resp.finalizeWrite?.status}`);
    }
  }
  async updateTags() {
    // console.log("TAGS IN UPDATE TAGS",tags)
    const pool = await getConnectionPool();
    // this.tags = this.tags.concat(tags);
    // console.log("TAGS IN UPDATE TAGS",this.tags)
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      updateTags: request.UpdateTags.create({
        parentPath: this.parentPath,
        fileName: this.fileName,
        tags: this.tags
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.updateTags.status)
    if (resp.updateTags?.status !== 0) {
      throw new Error(`Update Tags Failed ${resp.updateTags?.status}`);
    }
  }
  async emptyTrash(objects: string[], isFolders: boolean[]) {
    const pool = await getConnectionPool();
    const req = request.Request.create({
      id: null,
      reqCreateTime: Date.now(),
      emptyTrash: request.EmptyTrash.create({
        objects: objects,
        isFolders: isFolders,
      }),
    });
    const resp = await pool.sendAndWait(req);
    checkMigrate(resp.emptyTrash.status)
    if (resp.emptyTrash?.status !== 0) {
      throw new Error(`${resp.emptyTrash?.message}`);
    }
  }
};
